export const DATABASE_CONTENT_TYPE = 'database';

// Public macros
export const DATABASE_MACRO_KEY = 'orderly-database';
export const DATABASE_ENTRY_MACRO_KEY = 'orderly-database-entry';
export const DATABASE_VALUE_MACRO_KEY = 'orderly-database-value';

// Internal macros
export const DB_MACRO_KEY = 'orderly-db';
export const DB_FIELD_MACRO_KEY = 'orderly-db-field';
export const DB_ENTRY_MACRO_KEY = 'orderly-db-entry';
export const DB_VALUE_MACRO_KEY = 'orderly-db-value';

/**
 * A suffix to be appended to the database name when used for the title of database custom content objects.
 * Confluence has a bug where renaming pages can cause page links within custom content bodies to break,
 * see https://community.developer.atlassian.com/t/ri-page-reference-gets-removed-in-storage-format-when-custom-content-title-is-the-same-as-page-title/45114.
 * This happens when the custom content has the same title as a page that it's linking. To avoid such a
 * scenario, we append a suffix to the database custom content title to make it unlikely that there would
 * be a page with the same title.
 */
export const DATABASE_TITLE_SUFFIX = ' (Database)';
export const DATABASE_ENTRIES_TITLE_SUFFIX = ' (Database Content)';

export const UNNAMED_DATABASE_TITLE = 'Untitled database';
export const UNNAMED_VIEW_TITLE = 'View';

/** Columns in table view mode cannot be resized to anything more narrow than this */
export const TABLE_VIEW_HARD_COLUMN_MIN_WIDTH = 85;
/** Columns in table view mode with undefined width will have this minimum width applied */
export const TABLE_VIEW_SOFT_COLUMN_MIN_WIDTH = 200;

/** Number of times that a database value may reference another database value before breaking the recursion */
export const RECURSION_LIMIT = 10;
